var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as brandAction from '../actions/brand.action';
import { switchMap, mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined } from 'util';
import { BrandService } from '../../brand.service';
var BrandEffect = /** @class */ (function () {
    function BrandEffect(actions, brandService, store) {
        var _this = this;
        this.actions = actions;
        this.brandService = brandService;
        this.store = store;
        this.getAllBrands = this.actions.ofType(brandAction.GET_ALL_BRANDS)
            .pipe(switchMap(function () {
            return _this.brandService.getAllBrands()
                .map(function (res) { return new brandAction.GetAllBrandsSuccess(res); })
                .catch(function (error) { return of(new brandAction.GetAllBrandsError(error)); });
        }));
        this.getBrand = this.actions.ofType(brandAction.GET_BRAND)
            .pipe(withLatestFrom(
        // select brands.
        this.store.select(function (state) { return state.brandsFeature.brands.entities; }), function (action, brands) {
            // if no brands present, proceed for API.
            if (isNullOrUndefined(brands)) {
                return action;
            }
            else {
                // brands exists in store.
                var brand = brands.filter(function (b) { return b.id === action.payload; })[0];
                if (!!brand) {
                    // if required brand is present in store, then return;
                    return undefined;
                }
                else {
                    // if required brands not present in store, then proceed for API.
                    return action;
                }
            }
        }), filter(function (action) { return !!action; }), mergeMap(function (action) {
            return _this.brandService.getBrand(action.payload)
                .map(function (res) { return new brandAction.GetBrandSuccess(res); })
                .catch(function (error) { return of(new brandAction.GetBrandError(error)); });
        }));
        this.getBrandManagers = this.actions.ofType(brandAction.GET_BRAND_MANAGERS)
            .pipe(mergeMap(function (action) {
            return _this.brandService.getBrandManagers()
                .map(function (res) { return new brandAction.GetBrandManagersSuccess(res); })
                .catch(function (error) { return of(new brandAction.GetBrandManagersError(error)); });
        }));
        this.createBrand = this.actions.ofType(brandAction.ADD_BRAND)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.brandService.createBrand(body)
                .map(function (res) { return new brandAction.AddBrandSuccess(res); })
                .catch(function (error) { return of(new brandAction.AddBrandError(error)); });
        }));
        this.updateBrand = this.actions.ofType(brandAction.UPDATE_BRAND)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.brandService.updateBrand(body)
                .map(function (res) { return new brandAction.UpdateBrandSuccess(res); })
                .catch(function (error) { return of(new brandAction.UpdateBrandError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BrandEffect.prototype, "getAllBrands", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BrandEffect.prototype, "getBrand", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BrandEffect.prototype, "getBrandManagers", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BrandEffect.prototype, "createBrand", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BrandEffect.prototype, "updateBrand", void 0);
    return BrandEffect;
}());
export { BrandEffect };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/brands/store/effects/brand.effect.ts.pre-build-optimizer.js